// src/pages/auth/LoginPage.jsx
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoader from '../../Components/PageLoader';
import Footer from './../../Components/Footer';
import ForgotPassword from './../../Components/auth/ForgotPassword';

const ForgotPasswordPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { user } = useSelector(state => state.auth);

    // Redirect to dashboard if already authenticated
    useEffect(() => {
        if (user) {
            navigate('/admin/dashboard', { replace: true });
        }
    }, [user, navigate]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return <PageLoader />;
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
            {/* Header/Logo Area */}
            <div className="fixed top-0 left-0 right-0 p-4">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center">
                            {/* You can add your logo here */}
                            <span className="text-2xl font-bold text-green-600">
                                Admin Portal
                            </span>
                        </div>
                        {/* Add any additional header content here */}
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div className="min-h-screen flex flex-col">
                <main className="flex-grow flex items-center justify-center px-4 sm:px-6 lg:px-8">
                    <div className="w-screen">
                        <ForgotPassword />
                    </div>
                </main>

                {/* Footer */}
                <Footer />
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
